import { render, staticRenderFns } from "./albertcarbonfootprint.vue?vue&type=template&id=687e2e06&"
import script from "./albertcarbonfootprint.vue?vue&type=script&lang=js&"
export * from "./albertcarbonfootprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('687e2e06')) {
      api.createRecord('687e2e06', component.options)
    } else {
      api.reload('687e2e06', component.options)
    }
    module.hot.accept("./albertcarbonfootprint.vue?vue&type=template&id=687e2e06&", function () {
      api.rerender('687e2e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/albert/albertcarbonfootprint.vue"
export default component.exports